// Copyright (c) 2016 Deere & Company

import ClaimMaintenancePlan from '@deere/cps-it.warranty-model-factory/lib/claim-maintenance-plan';

export const getUpdatedClaim = (currentClaim, selectedAction) =>
    ClaimMaintenancePlan.update(currentClaim, {
        selectedAction: {
            $set: selectedAction
        }
    });



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/services/update-maintenance-plan-claim.js